import React,{useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { Button,Table,Container,Row,Col,Form } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';

function Master_city_List(){  
    const navigate = useNavigate();
    const [isMsgBox,setMsgBox] = useState(false); 
    const [msgText,setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [cityData, setCityData] = useState([]);

    const [showAddNewBtn,setShowAddNewBtn] = useState(true);
    const [showAddEditForm,setAddEditFormShow] = useState(false);
    const [srNo,setSrNo] = useState(0);
    const [city,setCity] = useState("");

    const [status,setStatus] = useState(0);
    const [ddActiveOptions,setDdActiveOptions] = useState([]);

    const [state,setState] = useState(0);
    const [ddStateOptions,setDdStateOptions] = useState([]);

    const [country,setCountry] = useState(0);
    const [ddCountryOptions,setDdCountryOptions] = useState([]);

    const [filterActiveCountry,setFilterActiveCountry] = useState(0);
    const [ddFilterActiveCountryOptions,setDdFilterActiveCountryOptions] = useState([]);

    const [filterActiveState,setFilterActiveState] = useState(0);
    const [ddFilterActiveStateOptions,setDdFilterActiveStateOptions] = useState([]);

    const [userRight,setUserRight] = useState([]);

    useEffect(()=>{
        if(onceRun){
            return;
        }else{
            setDdActiveOptions([{name:'Active',value:"1"},{name:'Inactive',value:"0"}]);
        
            /*Common.callApi(Common.apiCity,[sid,'listjson'],function(result){ 
                setCityData(JSON.parse(result));
            });*/
            Common.callApi(Common.apiRight,[sid,'all','CITY'],function(result){
                let resp = JSON.parse(result);
                if(resp.query==="1"){
                    setUserRight(resp);
                }else{
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiCountry,[sid,'ddlistjson'],function(result){ 
                setDdFilterActiveCountryOptions(JSON.parse(result));
                setDdCountryOptions(JSON.parse(result));
                setFilterActiveCountry(0);
            });
            Common.callApi(Common.apiState,[sid,'ddlistjson',filterActiveCountry],function(result){ 
                setDdStateOptions(JSON.parse(result));
                setDdFilterActiveStateOptions(JSON.parse(result));
            });
            setOnceRun(true);
        }
    },[onceRun,sid,navigate,filterActiveCountry]);

    function refreshFormState(id){
        setCountry(id);
        Common.callApi(Common.apiState,[sid,'ddlistjson',id],function(result){ 
            setDdStateOptions(JSON.parse(result));
        });
    }

    function refreshState(id){
        setFilterActiveCountry(id);
        Common.callApi(Common.apiState,[sid,'ddlistjson',id],function(result){ 
            setDdFilterActiveStateOptions(JSON.parse(result));
            filterActiveState(0);
        });
    }    

    function refreshList(id){
        setFilterActiveState(id);
        getList(id);
    }

    function getList(id){
        setFilterActiveState(id);
        Common.callApi(Common.apiCity,[sid,'listjson',id],function(result){ 
            setCityData(JSON.parse(result));
        });
    }

    function addNew(){
        setSrNo(0);
        setStatus(1);
        setCity("");
        setState(0);
        setCountry(0);
        setAddEditFormShow(true);
        setShowAddNewBtn(false); 
    }

    function saveData(){
        if(city==="" || state===0 || country===0){
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                srno: srNo,
                city: city,
                state: state,
                act: status
            };
            Common.callApi(Common.apiCity,[sid,'save',srNo,JSON.stringify(object1)],function(result){ 
                let resp = JSON.parse(result);
                if(resp.err===""){
                    setAddEditFormShow(false);
                    setShowAddNewBtn(true);
                    getList(filterActiveState);
                }else{
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function cancelData(){
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
    }

    function fillEditForm(id){
        Common.callApi(Common.apiCity,[sid,'detail',id],function(result){ 
            let resp = JSON.parse(result);
            setSrNo(resp.srno);
            setCity(resp.city);
            setState(resp.statesrno);
            setStatus(resp.active);

            setAddEditFormShow(true);
            setShowAddNewBtn(false); 
        });
    }

    return(
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>City Master </h1>
                    </Col>  
                </Row>
                {showAddNewBtn?
                    <Row>
                        <Col>
                            {userRight.add==="1"?
                                <Button  variant="outline-primary" size="sm"  onClick={addNew}>Add New</Button>                
                            :null}
                        </Col>
                    </Row>
                :null
                }
                <Row><Col>&nbsp;</Col></Row>
                {showAddEditForm?
                    <Row>
                        <Col className="divContentCenter">
                            <div className="maxFormWidth">
                                <Form>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Serial Number</Form.Label>
                                                <Form.Control type="text" placeholder="Serial Number" value={srNo} disabled />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>City<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="City" maxLength={50}
                                                 value={city} onChange={(e)=>setCity(e.target.value)}  autoComplete="off"/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Country<span className="mandatory">*</span></Form.Label>
                                                <Form.Select 
                                                    value={country}
                                                    onChange={(e)=>refreshFormState(e.target.value)}
                                                    >
                                                    {ddCountryOptions.map((res)=>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>State<span className="mandatory">*</span></Form.Label>
                                                <Form.Select 
                                                    value={state}
                                                    onChange={(e)=>setState(e.target.value)}
                                                    >
                                                    {ddStateOptions.map((res)=>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>                                        
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                                <Form.Select  
                                                    value={status}
                                                    onChange={(e)=>setStatus(e.target.value)}
                                                    >
                                                    {ddActiveOptions.map((res)=>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <Button  variant="outline-success" size="sm"  onClick={()=>saveData()}>Save</Button>&nbsp;
                                            <Button  variant="outline-danger" size="sm"  onClick={()=>cancelData()}>Cancel</Button>
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                :<>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Country</Form.Label>
                                <Form.Select  
                                    value={filterActiveCountry}
                                    onChange={(e)=>refreshState(e.target.value)}>
                                    {ddFilterActiveCountryOptions.map((res)=>
                                        <option key={res.value} value={res.value}>{res.name}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        
                        <Col>
                            <Form.Group>
                                <Form.Label>State</Form.Label>
                                <Form.Select  
                                    value={filterActiveState}
                                    onChange={(e)=>refreshList(e.target.value)}>
                                    {ddFilterActiveStateOptions.map((res)=>
                                        <option key={res.value} value={res.value}>{res.name}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        
                        <Col>&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        {userRight.edit==="1"? <th></th> :null}
                                        <th className="textRight">Sr No</th>
                                        <th>City</th>
                                        <th>city</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cityData.map((res) =>
                                        <tr key={res.city_id}>
                                            {userRight.edit==="1"?
                                                <td className="textCenter" >
                                                    <span className="handCursor" onClick={()=>fillEditForm(res.city_id) } >
                                                        <div className="colorThemeBlue"><FontAwesomeIcon icon={faEdit}  /></div>
                                                    </span>
                                                </td>
                                            :null
                                            }
                                            <td className="textRight">{res.city_id}</td>
                                            <td>{res.city_name}</td>
                                            <td>{res.state_name}</td>
                                            <td>{res.city_active}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </>
                }

            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e)=> setMsgBox(false) }>
                    {msgText}
                </Dialog>
            </div>
        </>
    );
}
export default Master_city_List; 